import Document from './Document'

export default Document
// eslint-disable-next-line import/export
export * from './Document'
